import template from './tsz-report-actions.html';
import './tsz-report-actions.styl';

function controller($state, $scope, $mdDialog, $tszToast, ReportService) {

  'ngInject';

  this.delete = (ev) => {
    ReportService.deleteAction(this.report, ev, () => {
      $scope.$emit('report_deleted', this.report.id);
    });
  };

  this.download = () => {
    ReportService.download(this.report);
  };

  this.export = () => {
    ReportService.export(this.report);
  };

  this.duplicate = () => {
    ReportService.duplicate(this.report.id)
    .then((response) => {
      $scope.$emit('report_duplicated', response);
    });
  };

  this.edit = () => {
    $state.go('report', { id: this.report.id });
  };

}

export default {
  template,
  bindings: {
    report: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-report-actions/tsz-report-actions.js